"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReceiptCopyType = exports.PrintOutputType = exports.PrintOutputAlign = exports.PrintOutputWidth = exports.PrintOutputHeight = exports.PrintOutputStyle = void 0;
var PrintOutputStyle;
(function (PrintOutputStyle) {
    PrintOutputStyle[PrintOutputStyle["Normal"] = 0] = "Normal";
    PrintOutputStyle[PrintOutputStyle["Bold"] = 1] = "Bold";
    PrintOutputStyle[PrintOutputStyle["Italic"] = 2] = "Italic";
})(PrintOutputStyle = exports.PrintOutputStyle || (exports.PrintOutputStyle = {}));
var PrintOutputHeight;
(function (PrintOutputHeight) {
    PrintOutputHeight[PrintOutputHeight["SingleHeight"] = 0] = "SingleHeight";
    PrintOutputHeight[PrintOutputHeight["DoubleHeight"] = 1] = "DoubleHeight";
    PrintOutputHeight[PrintOutputHeight["HalfHeight"] = 2] = "HalfHeight";
})(PrintOutputHeight = exports.PrintOutputHeight || (exports.PrintOutputHeight = {}));
var PrintOutputWidth;
(function (PrintOutputWidth) {
    PrintOutputWidth[PrintOutputWidth["SingleWidth"] = 0] = "SingleWidth";
    PrintOutputWidth[PrintOutputWidth["DoubleWidth"] = 1] = "DoubleWidth";
})(PrintOutputWidth = exports.PrintOutputWidth || (exports.PrintOutputWidth = {}));
var PrintOutputAlign;
(function (PrintOutputAlign) {
    PrintOutputAlign[PrintOutputAlign["Left"] = 0] = "Left";
    PrintOutputAlign[PrintOutputAlign["Center"] = 1] = "Center";
    PrintOutputAlign[PrintOutputAlign["Right"] = 2] = "Right";
})(PrintOutputAlign = exports.PrintOutputAlign || (exports.PrintOutputAlign = {}));
var PrintOutputType;
(function (PrintOutputType) {
    PrintOutputType[PrintOutputType["Text"] = 0] = "Text";
    PrintOutputType[PrintOutputType["NewLine"] = 1] = "NewLine";
    PrintOutputType[PrintOutputType["Separator"] = 2] = "Separator";
    PrintOutputType[PrintOutputType["Image"] = 3] = "Image";
})(PrintOutputType = exports.PrintOutputType || (exports.PrintOutputType = {}));
var ReceiptCopyType;
(function (ReceiptCopyType) {
    /** User wants the receipt to be sent via E-mail */
    ReceiptCopyType[ReceiptCopyType["Email"] = 0] = "Email";
    /**  User wants the receipt to be printed on paper at the POS */
    ReceiptCopyType[ReceiptCopyType["Paper"] = 1] = "Paper";
})(ReceiptCopyType = exports.ReceiptCopyType || (exports.ReceiptCopyType = {}));
